// Import model
import { FilterPickListRequest } from '../models/FilterPickListRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { PickListCondition } from '../models/PickListCondition';
import { PickListFields } from '../models/PickListFields';
import { PickListIndexedFields } from '../models/PickListIndexedFields';

// Import dependency serializers (for complex types)
import { PickListConditionSerializer } from './PickListConditionSerializer';
import { PickListFieldsSerializer } from './PickListFieldsSerializer';
import { PickListIndexedFieldsSerializer } from './PickListIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for FilterPickListRequest - handles JSON serialization and deserialization with type validation
 */
export class FilterPickListRequestSerializer {
  /**
   * Deserializes a JSON string into a FilterPickListRequest instance
   */
  static deserialize(json: string): FilterPickListRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a FilterPickListRequest instance
   */
  static fromObject(obj: any): FilterPickListRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to FilterPickListRequest');
    }


    const instance: FilterPickListRequest = {
      top: obj['top'] as number | undefined,
      skip: obj['skip'] as number | undefined,
      orderBy: obj['orderBy'] as PickListIndexedFields | undefined,
      reverseOrder: obj['reverseOrder'] as boolean | undefined,
      view: obj['view'] as string | undefined,
      fields: obj['fields'] ? (obj['fields'] as any[]).map((item: any) =>
        item as PickListFields
      ) : [] as any,
      criteria: obj['criteria'] ? (obj['criteria'] as any[]).map((item: any) =>
        PickListConditionSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of FilterPickListRequest instances
   */
  static deserializeArray(json: string): FilterPickListRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a FilterPickListRequest instance to a JSON string
   */
  static serialize(instance: FilterPickListRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a FilterPickListRequest instance to a plain object
   */
  static toObject(instance: FilterPickListRequest): any {
    return {
      'top': instance.top,
      'skip': instance.skip,
      'orderBy': instance.orderBy,
      'reverseOrder': instance.reverseOrder,
      'view': instance.view,
      'fields': instance.fields?.map((item: any) =>
        item
      ),
      'criteria': instance.criteria?.map((item: any) =>
        PickListConditionSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of FilterPickListRequest instances to a JSON string
   */
  static serializeArray(instances: FilterPickListRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
